import React from 'react';

import EmptyGoodsIcon from 'assets/empty-goods-icon';
import useTranslation from 'hooks/use-translation';
import { EmptyStateContainer, StyledHeader, StyledSubtext } from './empty-state-shared-styles';

const BrandsPageEmptyState = () => {
  const { t } = useTranslation();

  return (
    <EmptyStateContainer>
      <EmptyGoodsIcon />
      <StyledHeader>{t('brandsPageEmptyState.header', 'Select a brand to get started!')}</StyledHeader>
      <StyledSubtext>{t('brandsPageEmptyState.subtext', 'All available brands are listed to the left')}</StyledSubtext>
    </EmptyStateContainer>
  );
};

export default BrandsPageEmptyState;
